import type { ReactNode } from 'react';
import { Separator } from '~/components/ui/separator';
import { ResetButton } from '~/features/settings/ResetButton';
import { ThemeToggle } from '~/features/settings/ThemeToggle';
import { ShortcutsHelp } from '~/features/shortcuts/ShortcutsHelp';

type Props = {
  stepNav: ReactNode;
  toolbar: ReactNode;
  canvas: ReactNode;
};

export function AppShell({ stepNav, toolbar, canvas }: Props) {
  return (
    <div className="flex h-full flex-col gap-2 bg-background p-2">
      <header className="flex shrink-0 items-start gap-2 rounded-md border bg-card px-2 py-1">
        <div className="shrink-0 pt-0.5">{stepNav}</div>
        <Separator orientation="vertical" className="h-5" />
        <div className="relative min-w-0 flex-1">{toolbar}</div>
        <Separator orientation="vertical" className="h-5" />
        <div className="flex shrink-0 items-center gap-1 pt-0.5">
          <ThemeToggle />
          <ShortcutsHelp />
          <Separator orientation="vertical" className="mx-1 h-5" />
          <ResetButton />
        </div>
      </header>
      <main className="min-h-0 flex-1 overflow-hidden rounded-md border bg-card">{canvas}</main>
    </div>
  );
}
